import styled from "styled-components";
import { gray } from "../../../utils/styles";
import { hexToRgba } from "../../../utils/helpers";

const SearchSelectStyles = styled.div`
  &:focus {
    outline: 0;
  }
  input {
    text-transform: capitalize;
    display: block;
    padding-left: 45px !important;
    padding-right: 45px;
    position: relative;
    outline: none;
  }

  .search-container {
    position: relative;
    display: flex;
    margin-bottom: 0px !important;
  }

  .options {
    position: relative;
    display: block;
    min-width: 100%;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 15px;
    z-index: 10;
  }
  .options__header,
  .options__header--clickable {
    color: ${gray(400)};
    font-size: 12px;
    font-weight: bold;
    padding: 20px 16px 7.5px !important;
    margin: 0 !important;
  }
  .options__header:hover {
    background: #fff;
    cursor: auto;
  }
  .options__header--clickable:hover {
    background: #fff;
    cursor: pointer;
  }
  .option__popular-provider {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .options__military {
    display: flex;
    align-items: center;
  }
  .options__military-icon {
    margin-right: 9px;
  }
  .options__military-arrow-icon {
    margin-left: auto;
  }
  ul {
    max-height: 155px;
    min-width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    list-style: none;
    padding: 8px 0;
    margin: 0 !important;
    position: absolute;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 8px 15px rgba(000, 000, 000, 0.2);
    z-index: 1;
  }
  li {
    color: ${gray(400)};
    padding: 4px 16px;
    font-size: 16px;
    line-height: 20px;
    text-align: left;
  }
  li:before {
    display: none;
  }
  li:hover {
    cursor: pointer;
    background: ${(props) =>
      props.$primary_color ? hexToRgba(props.$primary_color, ".2") : gray(100)};
    transition: all 0.25s;
  }
  .labels {
    display: flex;
    justify-content: space-between;
  }
  .helptext {
    font-style: italic;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${gray(400)};
  }
  .search-icon {
    position: absolute;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    top: 5px;
    left: 8px;
  }
  .clear {
    color: #2459a9;
    font-size: 12px;
    position: absolute;
    top: 13px;
    right: 8px;
    &:hover {
      cursor: pointer;
    }
  }
`;

export default SearchSelectStyles;
